

import { OptionWCheckboxList } from "../../assets/helpers/helpers";
import {
    Feature,
    FeatureList,
    ProjectList,
} from "../../models/models";


// Shared empty result — a fresh [] on every call would get a new identity each
// time, which loops any effect that stores it in state and depends on it.
const EMPTY_FEATURES: FeatureList = [];

// A project may carry no features at all, and a product's projectId may not be
// present in the list — both cases must yield an empty list, not undefined.
export const getAvailableProjectFeatures = (
    currentProjectId: number,
    projects: ProjectList
): FeatureList => {
    return (
        projects?.find((project) => project.id === currentProjectId)
            ?.features ?? EMPTY_FEATURES
    );
};


const availableState = (
    availableFeature: Feature,
    activeFeatures: FeatureList | undefined
) => {
    return (
        activeFeatures?.find((feature) => feature.id === availableFeature.id) !== undefined
    );
};

export const prepareDataForSelectCheckbox = (
    availableFeatures: FeatureList | undefined,
    activeFeatures: FeatureList | undefined
): OptionWCheckboxList => {
    return (availableFeatures ?? []).map((availableFeature) => {
        return {
            id: availableFeature.id,
            name: availableFeature.name,
            checked: availableState(availableFeature, activeFeatures),
        };
    });
};
